import React, { useState, useEffect } from "react";
import ModalPageWrapper from "../../global-layout/modal-page-wrapper";
import { PageModalCloseIcon } from "../../svg";
import IconBtn from "../../form/icon-btn";
import { TextBtn } from "../../form/text-btn";

interface ScreenshotModalProps {
  imageSrc: string;
  isLoading: boolean;
  initialDescription?: string;
  onClose: () => void;
  onSave: (description: string) => void;
}

const ScreenshotModal: React.FC<ScreenshotModalProps> = ({
  imageSrc,
  isLoading,
  initialDescription,
  onClose,
  onSave,
}) => {
  const [description, setDescription] = useState<any>(initialDescription);
  useEffect(() => {
    setDescription(initialDescription);
  }, [initialDescription]);

  const handleSave = () => {
    onSave(description);
    // Note: We removed onClose() here so the parent can close it 
    // only after the API call succeeds (showing a loader in the meantime).
  };

  return (
    <ModalPageWrapper>
      <div className="fixed inset-0 z-[10000] w-full h-full flex justify-center items-center backdrop-blur-sm bg-black/60">
        <div className="w-[45%] h-auto bg-io-white dark:bg-io-black-1a rounded-[2.2rem] shadow-2xl max-md:w-[80%] flex flex-col overflow-hidden relative animate-fade-in-up">
          <div className="w-full h-auto p-6 pb-0 flex justify-between items-center">
            <h2 className="text-[2rem] font-inter font-semibold text-io-black dark:text-io-white ml-4">
              {initialDescription ? "Edit Description" : "Save Screenshot"}
            </h2>
            <IconBtn
              size="w-[3rem]"
              icon={<PageModalCloseIcon />}
              handleClick={onClose}
            />
          </div>
          <div className="w-full p-8 flex flex-col gap-6">
            <div className="w-full h-[25rem] bg-gray-100 dark:bg-black rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 flex justify-center items-center relative">
              {imageSrc ? (
                <img
                  src={imageSrc}
                  alt="Captured Screenshot"
                  className="h-full w-auto object-contain"
                />
              ) : (
                <span className="text-gray-400">No Image Captured</span>
              )}
            </div>
            <div className="w-full text-left">
              <label htmlFor="description" className="block text-[1.5rem] font-inter font-medium text-io-gray-66 dark:text-io-black-d1 mb-2">
                Description
              </label>
              <textarea
                id="description"
                rows={4}
                className="w-full text-[1.6rem] font-inter font-normal text-io-black dark:text-io-white bg-io-gray-f7 dark:bg-io-black-15 p-[1.5rem] rounded-[0.8rem] focus:outline-none focus:ring-2 focus:ring-io-primary resize-none border border-transparent focus:border-io-primary transition-all"
                placeholder="Enter a description for this screenshot..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="w-full flex justify-center items-center gap-20 mt-2">
              <div className="w-[12rem]">
                <TextBtn
                  label="Cancel"
                  btnStyle="fill-secondary"
                  btnType="button"
                  handleClick={onClose}
                />
              </div>
              <div className="w-[12rem]">
                <TextBtn
                  isLoading={isLoading}
                  label="Save"
                  btnStyle="fill-primary"
                  btnType="button"
                  handleClick={handleSave}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </ModalPageWrapper>
  );
};

export default ScreenshotModal;